import React, { useContext, useMemo, useState } from 'react';
import {
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import classnames from 'classnames/bind';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setLanguage } from 'features/core/reducer';
import { selectPage } from 'features/content/selectors';
import { ENV_VAR } from 'app/api';
import { getSearchWithoutLocale } from 'common/helpers/resolvePath';
import { selectMasterLanguage } from 'features/core/selectors';
import styles from './LanguageSwitcher.module.scss';
import userContext from 'common/utils/userContext';
import http from 'app/http';
import qs from 'qs';
import { selectCoreSettings } from 'features/content/selectors';

const FLAGS_PATH = `${process.env.PUBLIC_URL}/images/icons/flags/`;
const FLAGS_SIZE = 24;
const cx = classnames.bind(styles);

const LanguageSwitcher = () => {
  const match: any = useRouteMatch(
    '/:lang([a-z]{2}|[a-z]{2}-[a-z]{2})/portal/*',
  );
  const [isOpen, setIsOpen] = useState(false);
  const siteSettings = useAppSelector(selectCoreSettings);
  const directPaymentPageUrl = siteSettings?.LayoutModel?.SiteNavigationService?.DirectPaymentPage?.Uri;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const queryString =
    process.env.NODE_ENV === ENV_VAR.DEVELOPMENT
      ? getSearchWithoutLocale(search)
      : search; // Only for local development purpose
  // Language depends of content
  const coreContent: any = useAppSelector(
    selectPage(match?.params?.lang ? `/${match.params.lang}` : '/'),
  );
  // Get current page content to have localized urls
  const pageContent: any = useAppSelector(selectPage(pathname + queryString));
  const masterLanguage: string | null = useAppSelector(selectMasterLanguage);
  // Core localized urls
  const languages = useMemo(() => coreContent?.LocalizedUrls, [coreContent]);
  // Current page localized urls
  const currentPageLanguages = useMemo(
    () => pageContent?.LocalizedUrls,
    [pageContent],
  );
  const currentLanguage = useMemo(() => {
    return (languages || []).find(
      (lang: any) =>
        lang.Language === coreContent?.PageData?.Language ||
        lang.Language === coreContent?.PageData?.LanguageBranch,
    );
  }, [pageContent, languages]);

  const user = useContext(userContext);

  // Handle language change
  const onChange = async (lang: any) => {
    const currLangPath =
      lang?.Language !== masterLanguage ? `/${lang?.Language}` : '/';
try{
      if(user)
      {
        const response = await http.post(
          directPaymentPageUrl + 'UpdateLanguageResult',
          // Convert object into string
          qs.stringify({
            'shortLanguageCode': lang.Language
          }),
        );
        console.log('resp ' + response);
      }
    }
    catch (err) {
      console.error(err);
    }
    finally{
    history.push(lang?.Url);
    dispatch(setLanguage(currLangPath));
    }
  };



  const getLanguageDisplayName = (language:any) => {
    var displayLanguage=language.DisplayLanguageName;
    (languages || []).map((lang: any, index: number) => {
        if(lang.Language === language.Language)
        {
          displayLanguage = lang.DisplayLanguageName;
          return displayLanguage;
        }
      }
    )
      return displayLanguage;
  }

  // Styles
  const wrapperStyle = cx({
    isOpen: isOpen,
    wrapper: true,
  });

  return (
    <div className={wrapperStyle} onClick={() => setIsOpen(!isOpen)}>
      <div className={styles.current}>
        {currentLanguage && (
          <>
            <img
              src={`${FLAGS_PATH}${currentLanguage?.Language}.svg`}
              width={FLAGS_SIZE}
              height={FLAGS_SIZE}
              className={styles.flag}
            />
            <span className={styles.name}>
              {currentLanguage?.DisplayLanguageName}
            </span>
          </>
        )}
      </div>
      {isOpen && (
        <div className={styles.languages}>
          {(currentPageLanguages || []).map((lang: any, index: number) => (
            <button
              onClick={() => onChange(lang)}
              key={index}
              className={styles.language}
            >
              <img
                src={`${FLAGS_PATH}${lang.Language}.svg`}
                width={FLAGS_SIZE}
                height={FLAGS_SIZE}
                className={styles.flag}
                alt={`${lang.Language} flag`}
              />{' '}
              <span className={styles.name}>{getLanguageDisplayName(lang)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
